module.exports = {"tags":{"default":"skatīt visus","tags":["skatīt visus","Mindfit","Vadītāja ABC","Vadi procesus","E-simulācijas"]}}


//////////////////
// WEBPACK FOOTER
// ./src/data/tagsLV.json
// module id = 1EOv
// module chunks = 0